import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';


export function addJobStatusChangePopUpRun({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
    const executedByIdList = sectionComponent.customForm.current.state.componentDataSource.ExecutedById || [];
    const executedById = executedByIdList.find(item => item.Value === sectionComponent.props.authUser.key);
    setTimeout(() => {
        if (executedById) {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ ExecutedById: executedById.Value });
        }
    }, config.setTimeoutMilliSecond);
}


export function editJobStatusChangePopUpRun({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
    const executedByIdList = sectionComponent.customForm.current.state.componentDataSource.ExecutedById || [];
    const executedById = executedByIdList.find(item => item.Value === sectionComponent.props.authUser.key);
    setTimeout(() => {
        if (executedById) {
            sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ ExecutedById: executedById.Value });
        }
    }, config.setTimeoutMilliSecond);
}